export class PaymentLimitSettings {
	portfolioKey: number = -1;
	allowShortPay: boolean = true;
	requireShortPayReason: boolean = false;
	enableShortPayUserComment: boolean = false;
	allowOverPay: boolean = false;
	enableOverPayWarningMessage: boolean = false;
	shortPayReasons: string[] = [];
	selectedShortPayReason: number = -1;
    shortPayComment: string = '';
    minimumPaymentAmount: number = 0 || null;
    maximumPaymentAmount: number = 0 || null;
    enableMinimumPaymentDueOnAccount: boolean = false;
}